// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"423":"b0f19e18","671":"092556a3"}[chunkId] + ".chunk.css";
};